import {NgStyle} from '@angular/common';
import {Component, Input, numberAttribute} from '@angular/core';

//Composant simple image
@Component (
{
  selector: 'val-simple-image',
  imports: 
  [
    NgStyle
  ],
  templateUrl: './simple-image.component.html',
  styleUrl: './simple-image.component.scss'
})
export class SimpleImageComponent 
{
  //Création
  constructor () 
  {
    this.width = 0;
    this.height = 0;
    this.src = "";
  }

  //Largeur
  @Input ({transform: numberAttribute})
  public width: number;

  //Hauteur
  @Input ({transform: numberAttribute})
  public height: number;

  //Source
  @Input ()
  public src: string;
}
